import { MTMCustomFile } from '../mtm-custom-file';
import { TransferProgress } from '../transfer-progress';

export interface BaseUploadHandler {
  /**
   * Handles the upload process for a specific upload type
   * @param file - The file to upload
   */
  handleUpload(file: MTMCustomFile): void;

  /**
   * Checks if this handler can process the given file
   * @param file - The file to check
   * @returns true if this handler can process the file
   */
  canHandle(file: MTMCustomFile): boolean;
}

export abstract class AbstractUploadHandler implements BaseUploadHandler {
  public abstract handleUpload(file: MTMCustomFile): void;
  public abstract canHandle(file: MTMCustomFile): boolean;

  /**
   * Emits progress update for the file
   * @param file - The file being uploaded
   * @param progress - The progress data
   */
  protected emitProgress(file: MTMCustomFile, progress: TransferProgress): void {
    if (file.progress$) {
      file.progress$.next(progress);
    }
  }

  /**
   * Handles upload errors
   * @param file - The file being uploaded
   * @param error - The error that occurred
   */
  protected handleError(file: MTMCustomFile, error: any): void {
    file.uploadStatusCode = file.uploadStatusCode || 'ERROR';
    this.emitProgress(file, {
      status: 'ERROR',
      startIndex: file.startIndex || 0,
      error: error.message || error,
      step: 'error',
    });
  }
}
